<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Create New Branch
  </div>
  <div
    class="flx-modal-subtitle"
    flxModalHeaderSubtitle
  >
    Start a branch from "{{ data.fromBranchName || '-' }}"
  </div>

  <div
    [formGroup]="branchNameForm"
    (submitForm)="createBranch()"
    class="flx-modal-body"
    flxEnterSubmitForm
  >
    <flx-input class="flx-ds relative">
      <flx-label class="flx-ds mandatory">Branch name</flx-label>
      <input
        [maxlength]="maxLength"
        formControlName="branchName"
        data-testId="branch-name-input"
        flxAutofocus
        flxInput
        placeholder="Name your branch"
        type="text"
      />

      @if (submitted() && branchNameFC.errors; as errors) {
        <flx-error>
          @if (errors.maxlength) {
            Message must be less than {{ maxLength }} characters <br />
          }
          @if (errors.required) {
            Branch name is required <br />
          }
          @if (errors.pattern) {
            Name can contain only lowercase digits and dashes <br />
          }
        </flx-error>
      } @else {
        <flx-helper class="flex"> Name can contain lowercase, digits and dashes </flx-helper>
      }
      <span class="absolute right-0 bottom-0 text-xs text-gray-500"
        >{{ branchNameFC.value?.length || 0 }}/{{ maxLength }}</span
      >
    </flx-input>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        (click)="createBranch()"
        class="flx-ds primary"
        data-testId="save-branch-button"
        flxButton
        type="button"
      >
        Create Branch
      </button>
    </div>
  </div>
</flx-modal>
